import React from 'react'
import { KibSelect } from '@chewy/kib-fields-new-react'

import '@chewy/kib-fields-new-styles/dist/styles/kib-select.css'
import '@chewy/kib-tooltip-styles/dist/kib-tooltip.css'
import styles from './PaymentMethodSection.module.scss'

export interface PaymentDropdownOption {
  label: string
  selectable: boolean
  value: string
}

interface PaymentDropdownProps {
  disabled?: boolean
  label: string
  messages?: Record<string, string>
  onChange: (value: string) => void
  options: PaymentDropdownOption[]
  placeholder?: string
  required?: boolean
  value: string
}

const PaymentDropdown = ({
  label,
  value,
  onChange,
  options,
  disabled = false,
  required = false,
  placeholder,
  messages,
}: PaymentDropdownProps) => (
  <div className={styles.fieldContainer}>
    <KibSelect
      disabled={disabled}
      label={label}
      messages={messages}
      required={required}
      value={value}
      onChange={(e: any) => onChange(e.target.value)}
    >
      {placeholder && (
        <option disabled hidden value="">
          {placeholder}
        </option>
      )}
      {options.map((option) => (
        <option
          disabled={!option.selectable}
          key={option.value}
          value={option.value}
        >
          {option.label}
        </option>
      ))}
    </KibSelect>
  </div>
)

export default PaymentDropdown
